export const filterMovements = (type = "", movements = []) => {
  let movementsFiltered = []
  if (type.includes("ESTACION") || type.includes("MAYORISTA_E")) {
    movementsFiltered = movements.filter(mv => mv.type === "ESTACIONARIO" || mv.type === "ESTACION" || mv.type === "MAYORISTA_E" || mv.type === "TODOS")
  } else if (type === "PORTATIL" || type === "ANDEN" || type === "MAYORISTA_P") {
    movementsFiltered = movements.filter(mv => mv.type === "PORTATIL" || mv.type === "ANDEN" || mv.type === "MAYORISTA_P" || mv.type === "TODOS")
  }
  return movementsFiltered
}